module.exports = __webpack_public_path__ + "account/assets/load-more.b3f5d270.svg";